export default class LuigisRecoTypes {
    static get ITEM_DETAIL_ALTERNATIVES(): string {
        return 'item_detail_alternatives'
    }

    static get ITEM_DETAIL_COMPLEMENTS(): string {
        return 'item_detail_complements'
    }

    static get DISCOUNT(): string {
        return 'discount'
    }

    static get BASKET_POPUP(): string {
        return 'basket_popup'
    }
}
